import React from 'react';
import Icon from '../components/Icon';

const UserLocator = ({ getShopsAtUserPosition, isLocating, ariaLabel}) => (
  <button
    aria-label={ariaLabel}
    className={`user-locator input-group-text ${isLocating ? 'is-locating' : ''}`}
    onClick={() => getShopsAtUserPosition()}
  >
    <Icon icon='screenshot' aria-hidden="true" />
    <span className="spinner" aria-hidden="true" />
  </button>
);

export default UserLocator;
